import {
	Main,
	Root,
	SideNav,
	SideNavToggleButton,
	TopNav,
	TopNavEnd,
	TopNavStart,
} from '@atlaskit/navigation-system';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { RouteComponent, useRouter } from 'react-resource-router';

import { ErrorBoundary } from '../../../common/error-boundary';
import { useAuthData } from '../../../utils/auth-context';
import { AppSwitcher } from '../app-switcher';
import { HelpButton, HelpPanel, HelpProvider } from '../in-product-help';
import { NotificationsIndicator } from '../notifications';
import { AtlassianProductHome } from '../product-home';
import { UserProfile } from '../profile';

export const AppRouteComponentContent = () => {
	const [routerState] = useRouter();

	const SidebarComponent = routerState.route?.navigation;
	const { user } = useAuthData();
	const ufoName = routerState.route?.analyticsName;

	return (
		<Root>
			<HelpProvider>
				<TopNav>
					<TopNavStart>
						{SidebarComponent && (
							<SideNavToggleButton
								defaultCollapsed
								collapseLabel="Collapse sidebar"
								expandLabel="Expand sidebar"
							/>
						)}
						<ErrorBoundary>
							<AppSwitcher />
						</ErrorBoundary>
						<AtlassianProductHome />
					</TopNavStart>
					{user && (
						<TopNavEnd>
							<ErrorBoundary>
								<NotificationsIndicator />
							</ErrorBoundary>
							<ErrorBoundary>
								<HelpButton />
							</ErrorBoundary>
							<UserProfile user={user} />
						</TopNavEnd>
					)}
				</TopNav>
				{SidebarComponent && (
					<SideNav defaultWidth={200}>
						<SidebarComponent />
					</SideNav>
				)}
				<Main isFixed>
					<UFOSegment name={ufoName ?? ''}>
						<RouteComponent />
					</UFOSegment>
				</Main>
				<ErrorBoundary>
					<HelpPanel />
				</ErrorBoundary>
			</HelpProvider>
		</Root>
	);
};
